import type { InputDialogBaseButton, InputDialogBaseDefaultButton} from '../utils/DialogUtils';
import type * as React from 'react';

import Button from '@mui/material/Button';

import { isLinkButton } from '../utils/DialogUtils';

interface DialogButtonProps {
    button: InputDialogBaseButton;
    close?: () => void;
}

export const DialogButton: React.FC<DialogButtonProps> = (props) => {
    if (isLinkButton(props.button)) {
        return (
            <Button
                onClick={props.button.preventCloseCall ? undefined : props.close}
                color="primary"
                href={props.button.href}
                download={props.button.download}
                target="_blank"
            >
                {props.button.label}
            </Button>
        );
    }

    const clickButton: InputDialogBaseDefaultButton = props.button;

    function handleClick() {
        clickButton.callback?.('');

        if (props.close != null && !props.button.preventCloseCall) {
            props.close();
        }
    }

    return (
        <Button
            onClick={handleClick}
            color="primary"
        >
            {props.button.label}
        </Button>
    );
};